export default __webpack_public_path__ + "static/media/aerospace.c8ee4ade.svg";